module.exports = __webpack_public_path__ + "static/media/visa_black.3698a054.png";